
$(document).ready(function() {
  var pathname = window.location.pathname;  
  if(pathname == "/pages/wholesale-products" || pathname.indexOf('/products/') != -1){ 
    setCookie("previousProductUrl",window.location.href,1); 
    if(pathname == "/pages/wholesale-products"){
      setCookie("previousWholesaleUrl",window.location.href,1); 
    }
  } 
  var previousProductUrl = getCookie("previousProductUrl");
  if(previousProductUrl != '' && pathname == "/cart"){
    // console.log(previousProductUrl);
    $(".cart__exit__link").attr("href",previousProductUrl);
  } 

  var previousWholesaleUrl = getCookie("previousWholesaleUrl");
  if(previousWholesaleUrl != '' && pathname.indexOf('/products/') != -1){ 
    $(".return-link").attr("href",previousWholesaleUrl);
    $(".return-link-text").text("Back To Wholesale");
  }else if(previousWholesaleUrl != '' && pathname.indexOf('/collections/') != -1){
    setCookie("previousWholesaleUrl",'',1); 
  } 

  var cart_count = $(document).find(".header-wrapper .custom-count-get").text();
  $(document).find(".collection-product-popup .wholesale-cart-count").text(cart_count);
  
});

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

// function setCookie(kay,value) {
//   $.cookie(value, 1, {
//      expires : 1,
//      path    : '/',
//      domain  : window.location.host,   
//      secure  : true           
//   });
// }

// function getCookie(params) {
//   var cookieValue = $.cookie(params);
//   return cookieValue;
// }


$('.banner_slider .banner_list').slick({
  dots: true,
  infinite: true,
  arrows: false,
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: true
});

$('.reviews_inner .customer_list').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
   
  ]
});


$('.featured_collection_main .product_list').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 371,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
   
  ]
});

$('.featured_collection .product_list').slick({ 
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 2,
   rows: 2,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesPerRow: 2,
        rows: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 371,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
   
  ]
});


$('.product__related .product_list').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 371,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
   
  ]
});


document.addEventListener( 'DOMContentLoaded', function () {
  $('.description_main ul.tabs').each(function(){
    var active, content, links = $(this).find('a');
    active = links.first().addClass('active');
    content = $(active.attr('href'));
    links.not(':first').each(function () {
      $($(this).attr('href')).hide();
    });
    $(this).find('a').click(function(e){
      active.removeClass('active');
      content.hide();
      active = $(this);
      content = $($(this).attr('href'));
      active.addClass('active');
      content.show();
      return false;
    });
  });
}, false );


$(document).on("click",".add_to_cart_btn",function(event) {
  event.preventDefault();
  var form_id = $(this).attr("form-id");
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: $("#"+form_id).serialize(),
    dataType: 'json',
    success: function(cart) { 
      jQuery.getJSON('/cart.js', function(cart) {
        const itemCount = cart.item_count; 
        $(".cart-count-bubble").text(itemCount);
        $(document).find(".collection-product-popup .wholesale-cart-count").text(itemCount);
      });   
      $("."+form_id).html("Added To Cart");
      setTimeout(function() {
          $("."+form_id).html("");
      }, 2000); 
    },
    error: function() {
      
    }
  });
});
    